import React, { PropTypes } from 'react';
import { FontIcon } from 'material-ui';
import RemoveFile from './removeFile';
import FileName from './fileName';

const PowerPointPreview = props => {
  const {
    removeFile,
    url,
    fileName,
    showCaption,
    openGallery,
    showGallery,
    fullSize,
  } = props;

  return (
    <div style={{ display: 'inline-block', maxHeight: fullSize && '550px', width: fullSize ? '100%' : '150px', height: fullSize ? '' : '100px', position: 'relative' }}>
      <div style={{ height: '100%', width: '100%' }} onTouchTap={showGallery && openGallery}>
        <div style={{ cursor: showGallery ? 'pointer' : 'default', border: fullSize ? '' : '2px solid #D3D3D3', width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <FontIcon
            className="tc-icon-subscriptions"
            style={{ color: fullSize ? '#FFFFFF' : 'rgba(138,138,138,.5)', verticalAlign: 'middle', fontSize: fullSize ? '150px' : '40px' }}
            hoverColor="#00bcd4"
          />
        </div>
        {(showCaption || fullSize) && <FileName fileName={fileName} fileNameStyle={{ color: '#FFFFFF', fontSize: '16px' }} />}
      </div>
      {removeFile && <RemoveFile
        removeFile={() => removeFile(url)}
        left="84%"
      />}
    </div>
  );
};

PowerPointPreview.propTypes = {
  url: PropTypes.string,
  removeFile: PropTypes.func,
  fileName: PropTypes.string,
  openGallery: PropTypes.func,
  showGallery: PropTypes.bool,
  fullSize: PropTypes.bool,
  showCaption: PropTypes.bool,
};

export default PowerPointPreview;



// WEBPACK FOOTER //
// ./src/app/components/extra/filePreview/pptPreview.jsx